import { createInstance } from '@optimizely/react-sdk';

export const optimizely = createInstance({
    sdkKey: __OPTIMIZELY_SDK_KEY__,
    datafileOptions: {
        autoUpdate: true,
        updateInterval: 5 * 60 * 1000,
    },
});
optimizely.setUser({id: '123'});
